
import BrandService from './BrandService';

export { default } from './BrandService';
export const brandService = new BrandService();
